var render, staticRenderFns
import script from "./BrickConnection.vue?vue&type=script&lang=js&"
export * from "./BrickConnection.vue?vue&type=script&lang=js&"
import style0 from "./BrickConnection.vue?vue&type=style&index=0&id=724b4431&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724b4431",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\marketingdatabase-git\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('724b4431')) {
      api.createRecord('724b4431', component.options)
    } else {
      api.reload('724b4431', component.options)
    }
    
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/CanvasArea/Bricks/BrickConnection.vue"
export default component.exports